type ProjectStatus = {
  label: string;
  description: string;
  color: string;
};

const projectStatus: ProjectStatus = {
  color: "",
  label: "",
  description: "",
};

export type { ProjectStatus };

export { projectStatus };
